import { render, staticRenderFns } from "./EditToolTab.vue?vue&type=template&id=1dd20ea0&scoped=true&"
import script from "./EditToolTab.vue?vue&type=script&lang=js&"
export * from "./EditToolTab.vue?vue&type=script&lang=js&"
import style0 from "./EditToolTab.vue?vue&type=style&index=0&id=1dd20ea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd20ea0",
  null
  
)

export default component.exports